import { render, staticRenderFns } from "./UpdateCryptoInvestPurpose.vue?vue&type=template&id=782dcab2&scoped=true"
import script from "./UpdateCryptoInvestPurpose.vue?vue&type=script&lang=js"
export * from "./UpdateCryptoInvestPurpose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782dcab2",
  null
  
)

export default component.exports